import { render, staticRenderFns } from "./EditarDadosAgendamento.vue?vue&type=template&id=3d953390&"
import script from "./EditarDadosAgendamento.vue?vue&type=script&lang=js&"
export * from "./EditarDadosAgendamento.vue?vue&type=script&lang=js&"
import style0 from "./EditarDadosAgendamento.vue?vue&type=style&index=0&id=3d953390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports